import { CurriculumProgressDTO } from '@peartherapeutics/hylia-api-client';
import getHyliaApiClient from 'clients/hylia-api';

export const getPatientCurriculumProgress = async (
  patientId: string,
  accessRightId: string,
): Promise<CurriculumProgressDTO> => {
  const api = await getHyliaApiClient();
  const overview = await api.getPatientCurriculumProgress(
    patientId,
    accessRightId,
  );
  return overview.data;
};

export const lessonService = {
  getPatientCurriculumProgress,
};
